class DF.Views.Overlays.Loading extends Backbone.Enhanced.View

  el: 'body'

  ATTRIBUTES:
    last_shown: Date.now()

  initialize: ->
    @listenTo(DF.Events, 'overlay:show', @_showOverlay)
    @listenTo(DF.Events, 'overlay:hide', @_hideOverlay)

  render: ->
    # TODO

  _sleep = (start, ms) ->
    continue while new Date().getTime() - start < ms

  _showOverlay: ->
    $('.overlay').addClass('active')
    @set 'last_shown', Date.now()

  _hideOverlay: ->
    _sleep(@get('last_shown'), 1400)
    $('.overlay').removeClass('active')

module.exports = DF.Views.Overlays.Loading